export default [
  {
    name: 'label.cs',
    label: {
      cs: 'Popisek [CS]',
      en: 'Label [CS]',
    },
    main: true,
    input: 'input',
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'label.en',
    label: {
      cs: 'Popisek [EN]',
      en: 'Label [EN]',
    },
    main: true,
    input: 'input',
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'logo',
    label: {
      cs: 'Logo',
      en: 'Logo',
    },
    input: 'select-menu',
    elements: [
      { value: 'baseball-czech', label: 'Baseball Czech' },
      { value: 'eurobaseball-2023', label: 'Eurobaseball 2023' },
      { value: 'facebook', label: 'Facebook' },
      { value: 'instagram', label: 'Instagram' },
      { value: 'twitter', label: 'Twitter' },
      { value: 'wbsc', label: 'WBSC' },
      { value: 'wbsc-europe', label: 'WBSC Europe' },
      { value: 'youtube', label: 'YouTube' },
    ],
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'link',
    label: {
      cs: 'Odkaz',
      en: 'Link',
    },
    input: 'input',
    type: 'string',
    minLength: 2,
    maxLength: 128,
    required: true,
  },
];
